"use client";
import { jsxs as v, jsx as s } from "react/jsx-runtime";
import { Root as u, Track as b, Range as g, Thumb as w } from "@radix-ui/react-slider";
import { cva as y } from "class-variance-authority";
import * as N from "react";
import { cn as o } from "./index.es21.js";
const A = y("", {
  variants: {
    variant: {
      light: "bg-white",
      dark: "bg-gray-800"
    }
  }
}), T = ({
  className: c,
  defaultValue: a,
  value: i,
  min: l = 0,
  max: n = 100,
  variant: h = "dark",
  trackProps: t = {},
  thumbProps: r = {},
  rangeProps: e = {},
  ...f
}) => {
  const m = N.useMemo(() => Array.isArray(i) ? i : Array.isArray(a) ? a : [l, n], [i, a, l, n]);
  return /* @__PURE__ */ v(
    u,
    {
      "data-slot": "slider",
      defaultValue: a,
      value: i,
      min: l,
      max: n,
      className: o([
        "relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
        c
      ]),
      ...f,
      children: [
        /* @__PURE__ */ s(
          b,
          {
            "data-slot": "slider-track",
            ...t,
            className: o(
              "bg-gray-400 relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-1 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1",
              (t == null ? void 0 : t.className) || ""
            ),
            children: /* @__PURE__ */ s(
              g,
              {
                "data-slot": "slider-range",
                ...e,
                className: o(
                  "absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full",
                  A({ variant: h }),
                  (e == null ? void 0 : e.className) || ""
                )
              }
            )
          }
        ),
        Array.from({ length: m.length }, (z, d) => /* @__PURE__ */ s(
          w,
          {
            "data-slot": "slider-thumb",
            "aria-label": `slider-thumb-${d + 1}`,
            ...r,
            className: o(
              "border-primary bg-background ring-ring/50 block size-4 shrink-0 rounded-full border shadow-sm transition-[color,box-shadow] hover:ring-4 focus-visible:ring-4 focus-visible:outline-hidden disabled:pointer-events-none disabled:opacity-50 hover:cursor-pointer",
              (r == null ? void 0 : r.className) || ""
            )
          },
          d
        ))
      ]
    }
  );
};
export {
  T as Slider
};
